import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { State, useAppDispatch } from "../../../state/store";
import { Loading } from "../common/Loading";
import { Navigate, useParams } from "react-router-dom";
import { InformationId } from "../../../domain/information/InformationId";
import { getInformationAction } from "../../../state/usecase/information/actions";
import { useSendLocationToGtag } from "../../hooks/common/useSendLocationToGtag";
import { BackLink } from "./components/BackLink";
import { InformationDetail } from "./components/InformationDetail";
import { Paths } from "../../../Paths";

type InformationPagePathParams = {
    informationId: string
}

export function InformationPage() {
    const dispatch = useAppDispatch();

    useSendLocationToGtag("お知らせ詳細");

    const { informationId: id }= useParams<InformationPagePathParams>();

    if (!id) {
        return <Navigate to={Paths.root} />;
    }

    const informationId = useMemo<InformationId>(() => InformationId.fromString(id), [id]);

    const processing = useSelector((state: State) => state.information.processing);

    useEffect(() => {
        dispatch(getInformationAction(informationId));
    }, [dispatch, informationId]);

    // レスポンス取得中
    if (processing > 0) return <Loading />;

    return (
        <div className={"information_page"}>
            <div className={"container"}>
                <h1 className={"title"}>お知らせ</h1>
                <BackLink position={"left"} />
                <InformationDetail />
                <BackLink position={"center"} />
            </div>
        </div>
    );
}
